import {
  Button,
  Grid,
  Typography,
} from "@mui/material";
import DialogForm from "../../../shared/components/DialogForm";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import {
  createRecord,
  fetchList,
} from "../../../apis/services/CommonApiService";
import { ApiEndPoints } from "../../../apis/ApiEndPoints";
import { toast } from "react-toastify";
import {
  marketHotelListFailed,
  marketHotelListSuccess,
} from "../../../Reducer/roomRateSlice";
import { connect } from "react-redux";
import PlacesAutocomplete from "react-places-autocomplete";
import SmallLoader from "../../../layout/SmallLoader";

const AddMarketHotelDialog = (propsDia) => {
  const { t } = useTranslation();

  let {
    openAddHotelDialog,
    setOpenAddHotelDialog,
    marketHotelListSuccess,
    marketHotelListFailed,
  } = propsDia;



  const [selectedHotel, setSelectedHotel] = useState({
    competitor_hotel_name: "",
    competitor_hotel_id: "",
  });


  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");

  const handleSelectAddress = async (selectedAddress, setFieldValue) => {
    try {
      setAddress(selectedAddress);
      setSelectedHotel({
        competitor_hotel_name: selectedAddress,
        competitor_hotel_id: 0,
      })
    } catch (error) {
      console.error("Error selecting address:", error);
    }
  };

 
  const handleAddHotel = async () => {
    if(selectedHotel?.competitor_hotel_name === ""){
      toast.error("Please Select Hotel")
      return
    }
    setLoading(true);

    const result = await createRecord(
      selectedHotel,
      ApiEndPoints.ADD_MARKET_ANALYSIS_HOTEL
    );
    if (result?.status === 200) {
      setLoading(false);
      toast.success(t(result?.message));
      getHotelListNew();
      setOpenAddHotelDialog(false);
    } else {
      setLoading(false);
      toast.error(t(result?.message));
      setOpenAddHotelDialog(false);
    }
  };

  const getHotelListNew = async () => {
    const result = await fetchList(
      ApiEndPoints.GET_MARKET_ANALYSIS_HOTEL_LIST +
        `?page_no=${1}&items_per_page=${10}`
    );
    if (result?.status === 200) {
      marketHotelListSuccess([
        ...result?.data?.rows,
        { competitor_hotel_name: "Average Price", id: "average" },
      ]);
    } else {
      marketHotelListFailed();
    }
  };

  const searchOptions = {
    types: ["lodging"], // Filters results to only hotels
    // componentRestrictions: { country: "US" }, // Optional: Restrict results to a specific country
  };

  return (
    <DialogForm
      scroll="paper"
      // maxWidth="lg"
      maxWidth="md"
      title={t("Add Market Analysis Hotel")}
      openDialog={openAddHotelDialog}
      handleDialogClose={() => setOpenAddHotelDialog(false)}
      bodyContent={
        <div className="p-2">
          {loading && <SmallLoader />  }
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item 
            // lg={8} md={8} 
            sm={12} xs={12}>
              <Typography
                id="font-600"
                style={{
                  marginBottom: "11px",
                  color: "rgb(30, 30, 30)",
                  fontSize: "16px",
                  lineHeight: "24px",
                }}
              >
                {t("Search Hotel")}
              </Typography>
              <PlacesAutocomplete
                value={address}
                onChange={setAddress}
                onSelect={handleSelectAddress}
                searchOptions={searchOptions}

              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div>
                    <input
                      {...getInputProps({
                        placeholder: t("Search Hotels ..."),
                        className: "location-search-input",
                      })}
                      style={{
                        padding: "14px",
                        border: "1px solid #B4ADAD",
                        color: "#255480",
                        borderRadius: "6px",
                        width: "100%",
                        position: "relative",
                      }}
                    />
                    <div
                      className="autocomplete-dropdown-container"
                      style={{
                        position: "relative",
                        outline: "none",
                        zIndex: "1",
                        listStyle: "none",
                        padding: "0",
                        margin: "10px 0 10px -1px",
                        boxShadow: "1px 2px 18px rgba(0,0,0,0.25)",
                        backgroundColor: "white",
                        width: "100%",
                        maxHeight: "220px",
                        overflowY: "scroll",
                        borderRadius: "7px",
                      }}
                    >
                      {loading && (
                        <div
                          style={{
                            padding: "5px",
                            borderBottom: "1px solid #fafafa",
                          }}
                        >
                          {t("Loading...")}
                        </div>
                      )}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active
                          ? "suggestion-item--active"
                          : "suggestion-item";
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? {
                              backgroundColor: "#fafafa",
                              cursor: "pointer",
                              padding: "5px",
                              borderBottom: "1px solid #fafafa",
                            }
                          : {
                              backgroundColor: "#ffffff",
                              cursor: "pointer",
                              padding: "5px",
                              borderBottom: "1px solid #fafafa",
                            };
                        return (
                          <div
                            key={suggestion.placeId}
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style,
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
            </Grid>
            <Grid item lg={12} sm={12} xs={12}>
              <Button
                className=" comman-button"
                size="large"
                variant="contained"
                onClick={handleAddHotel}
                disableElevation
                color="primary"
              >
                {t("Submit")}
              </Button>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    marketHotelList: state.roomRate.marketHotelList,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    marketHotelListSuccess: (data) =>
      dispatch(marketHotelListSuccess(data)),
    marketHotelListFailed: () => dispatch(marketHotelListFailed()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddMarketHotelDialog);
